import { useCallback, useEffect, useState } from "react";

const useComponentHeight = (ref: React.RefObject<HTMLDivElement>) => {
  const [height, setHeight] = useState(0);

  const handleResize = useCallback(() => {
    if (ref.current) {
      setHeight(ref.current.offsetHeight);
    }
  }, [ref]);

  useEffect(() => {
    let dimensionsTimeout = setTimeout(() => {
      handleResize();
    }, 500);
    window.addEventListener("load", handleResize);
    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(dimensionsTimeout);
      window.removeEventListener("load", handleResize);
      window.removeEventListener("resize", handleResize);
    };
  }, [ref, handleResize]);

  return { height, recalculateHeight: handleResize };
};

export default useComponentHeight;
